import { render, staticRenderFns } from "./language-switch.vue?vue&type=template&id=47ec0cf0&scoped=true&"
import script from "./language-switch.vue?vue&type=script&lang=js&"
export * from "./language-switch.vue?vue&type=script&lang=js&"
import style0 from "./language-switch.vue?vue&type=style&index=0&id=47ec0cf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec0cf0",
  null
  
)

export default component.exports